import * as actionTypes from 'actions';

const initialState = {
  campaignsList: [],
  departmentsList: [],
  designationsList: [],
  // other states...
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EMP_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaignsList: action.payload,
        Loading: false,
      };

    case actionTypes.EMP_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departmentsList: action.payload,
        Loading: false,
      };

    case actionTypes.EMP_DESIGNATIONS_SUCCESS:
      return {
        ...state,
        designationsList: action.payload,
        Loading: false,
      };

    default: {
      return state;
    }
  }
};

export default employeeReducer;
